var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"exclude":['product_detail','journalism_detail','college_detail']}},[_c('router-view',{attrs:{"width":_vm.width}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }